var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class LightGallery extends Component {
    constructor() {
        super('LightGallery', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.light-gallery').each((gallery) => __awaiter(this, void 0, void 0, function* () {
                if (gallery.data('dynamic')) {
                    gallery.on('click', () => {
                        lightGallery(gallery.get(0), {
                            dynamic: true,
                            dynamicEl: JSON.parse(atob(gallery.data('images'))),
                            download: false,
                            hideBarsDelay: 0,
                            counter: false
                        });
                    });
                }
                else {
                    lightGallery(gallery.get(0), {
                        selector: '.light-gallery-item',
                        download: false,
                        hideBarsDelay: 0,
                        counter: false
                    });
                }
            }));
            this.success();
        });
    }
}
